import React from 'react';
import PropTypes from 'prop-types';
import I18n from 'apps/new-web/views/components/i18n';
import Icon from 'apps/new-web/views/components/icon';
import CALENDAR_ADD_LINE from '@ifit/react-icons/dist/icons/CALENDAR_ADD_LINE';
import { white } from 'apps/new-web/views/themes/colors';

const CTA = ({ link, user, toggleModal }) => {
  return (
    <div className="cta">
      {React.createElement(
        user ? 'button' : 'a',
        user ? { onClick: toggleModal } : { href: link },
        <div className="learn-more">
          <I18n desc={ user ? 'Link inviting user to schedule a workout.' : 'Link inviting user to sign in to schedule a workout.' }>
            {user ? 'Schedule Workout' : 'Sign in to Schedule Now'}
          </I18n>
          <Icon icon={ CALENDAR_ADD_LINE } size={ 24 } color={ white } />
        </div>
      )}
    </div>
  );
};

CTA.propTypes = {
  link: PropTypes.string,
  user: PropTypes.user,
  toggleModal: PropTypes.function
};

export default CTA;
